<template>
  <div id="mycover">
    <router-view :key="$route.fullPath"></router-view> 
  </div>
</template>

<script>
import axios from 'axios';

// Mixin fuer diese Komponente importieren
import commonvars from './components/mixins/commonvars.js';

export default {
  name: 'mycover',
  mixins: [
    commonvars
  ],
  created() {
    document.title = this.app_title();
  },
  mounted: function() {
    this.set_access_token_aus_localstorage_falls_vorhanden();
    this.append_css();

  },
  methods: {
    append_css() {
      let file = document.createElement('link');
      file.rel = 'stylesheet';
      file.href = window.global_mycover.server_base_url + '/css/mycover.css'
      console.log("Hinzuladen von " + file.href);
      document.head.appendChild(file)
    },
    set_access_token_aus_localstorage_falls_vorhanden() {
      let access_token = localStorage.getItem('access_token');
      if (access_token) {
        console.log("Ich habe ein access token im localstorage gefunden, setze das im Axios-Header als Default");
        axios.defaults.headers.common["Authorization"] = access_token;
      } else {
        console.log("Ich habe _kein_ access token im localstorage gefunden");
      }

    }
  }
};
</script>


 